import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ToutComprendrePage() {
  const [activeGuide, setActiveGuide] = useState('photovoltaique');

  const guides = {
    photovoltaique: {
      img: '/assets/images/AdobeStock_208731473.jpeg',
      title: 'Panneaux Solaires Photovoltaïques',
      how: "Les panneaux photovoltaïques transforment directement la lumière du soleil en électricité grâce à l'effet photovoltaïque. Les cellules de silicium captent les photons et génèrent un courant électrique continu, transformé en courant alternatif par l'onduleur.",
      avantages: [
        '80% de réduction sur vos factures d\'électricité',
        'Le soleil ne vous envoie pas de facture',
        '25 ans de garantie, 30+ ans de fonctionnement',
        'Énergie 100% propre et renouvelable',
        'Augmente la valeur de votre bien',
      ],
      types: [{ title: 'Autoconsommation', desc: 'Consommez votre propre électricité et vendez le surplus à EDF' }, { title: 'Vente totale', desc: 'Vendez toute votre production à EDF OA' }],
      aides: "Prime à l'autoconsommation d'EDF (selon puissance), TVA à 10%, MaPrimeRénov' et CEE selon les conditions.",
    },
    pac: {
      img: '/assets/images/PompeaChaleur.jpeg',
      title: 'Pompes à Chaleur (PAC)',
      how: "Une pompe à chaleur capte les calories présentes dans l'air extérieur (PAC air/eau ou air/air) ou dans le sol (PAC géothermique) et les transfère dans votre logement. Pour 1 kWh électrique consommé, elle produit 3 à 5 kWh de chaleur.",
      avantages: [
        '70% d\'économies sur les factures de chauffage',
        'Chaleur en hiver ET climatisation en été',
        'Utilise les énergies naturelles gratuites',
        'Réduction de l\'empreinte carbone de -75%',
        'Compatible avec plancher chauffant et radiateurs',
      ],
      types: [{ title: 'PAC Air-Eau', desc: 'Pour le chauffage central et l\'eau chaude sanitaire' }, { title: 'PAC Air-Air', desc: 'Pour le chauffage et la climatisation réversible' }],
      aides: "MaPrimeRénov' jusqu'à 5 000€, CEE, éco-PTZ, TVA à 5,5%.",
    },
    isolation: {
      img: '/assets/images/ISOLATION.jpg',
      title: 'Isolation Thermique',
      how: "L'isolation thermique consiste à poser des matériaux résistants au transfert de chaleur (laine de verre, laine de roche, polystyrène expansé...) sur les parois de votre logement pour limiter les échanges thermiques entre l'intérieur et l'extérieur.",
      avantages: [
        '60% d\'économies sur les factures de chauffage',
        'Confort thermique été comme hiver',
        'Amélioration du DPE et de la valeur du bien',
        'Réduction des nuisances sonores',
        'Élimination des condensations et moisissures',
      ],
      types: [{ title: 'ITE', desc: 'Isolation Thermique Extérieure - La plus performante' }, { title: 'ITI', desc: 'Isolation Thermique Intérieure - Sans modification extérieure' }],
      aides: "MaPrimeRénov' jusqu'à 15 000€, CEE, éco-PTZ, TVA à 5,5%.",
    },
  };

  const guide = guides[activeGuide];

  return (
    <>
      {/* Hero */}
      <section className="page-hero" style={{ background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('/assets/images/TOUTCOMPRENDRE.jpeg') center/cover" }}>
        <div className="container" style={{ width: '100%' }}>
          <div className="hero-content">
            <h1 className="hero-title">Tout <span className="text-accent">Comprendre</span></h1>
            <p className="hero-subtitle">Guide complet des énergies renouvelables pour vous accompagner dans votre projet de rénovation énergétique.</p>
            <div className="hero-buttons" style={{ justifyContent: 'center', maxWidth: '400px', margin: '0 auto' }}>
              <Link to="/#contact" className="btn btn-primary" style={{ padding: '14px 28px', fontSize: '1rem' }}>Demander un devis gratuit</Link>
              <a href="tel:0465845177" className="phone-number" style={{ color: 'white', borderColor: 'white' }}>04 65 84 51 77</a>
            </div>
          </div>
        </div>
      </section>

      {/* Guide navigation */}
      <section style={{ padding: '60px 0 20px', background: 'white' }}>
        <div className="container">
          <div className="section-header">
            <h2>Guide complet des <span className="text-accent">énergies renouvelables</span></h2>
            <p>Sélectionnez une solution pour en savoir plus</p>
          </div>
          <div className="tab-buttons" style={{ marginBottom: '50px' }}>
            {[
              { id: 'photovoltaique', label: 'Panneaux solaires' },
              { id: 'pac', label: 'Pompes à chaleur' },
              { id: 'isolation', label: 'Isolation' },
            ].map((t) => (
              <button key={t.id} className={`tab-btn ${activeGuide === t.id ? 'active' : ''}`} onClick={() => setActiveGuide(t.id)} data-testid={`guide-tab-${t.id}`}>
                {t.label}
              </button>
            ))}
          </div>

          <div className="guide-card">
            <img src={guide.img} alt={guide.title} className="guide-image" />
            <div className="guide-content">
              <h3>{guide.title}</h3>
              <div className="guide-section-content">
                <h4>Comment ça fonctionne ?</h4>
                <p>{guide.how}</p>
              </div>
              <div className="guide-section-content">
                <h4>Avantages principaux</h4>
                <ul className="guide-list">
                  {guide.avantages.map((a) => (<li key={a}><strong>✅ </strong>{a}</li>))}
                </ul>
              </div>
              <div className="guide-section-content">
                <h4>Types d'installations</h4>
                <div className="installation-types">
                  {guide.types.map((t) => (
                    <div className="type-card" key={t.title}>
                      <strong>{t.title}</strong>
                      <p style={{ fontSize: '0.9rem', color: '#7F8C8D' }}>{t.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="guide-section-content">
                <h4>Aides financières disponibles</h4>
                <p>{guide.aides}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Financial Aids detail */}
      <section className="aids-guide">
        <div className="container">
          <div className="section-header">
            <h2>Toutes les <span className="text-accent">aides financières</span></h2>
            <p>L'État vous aide à financer votre rénovation énergétique</p>
          </div>
          <div className="aids-grid">
            {[
              { title: "Ma Prime Rénov'", amount: 'Jusqu\'à 20 000€', desc: "Aide de l'État pilotée par l'Anah, accessible à tous les propriétaires. Montant variable selon les revenus et les travaux réalisés.", conditions: ["Propriétaire occupant ou bailleur", "Logement de plus de 15 ans", "Artisan certifié RGE obligatoire", "Demande avant les travaux"] },
              { title: "Certificats d'Économie d'Énergie (CEE)", amount: 'Jusqu\'à 20 000€', desc: "Primes versées par les fournisseurs d'énergie pour compenser leurs obligations de réduction des consommations. Cumulable avec MaPrimeRénov'.", conditions: ["Quasiment tous les travaux éligibles", "Artisan certifié RGE", "Signature avant travaux", "Cumulable avec d'autres aides"] },
              { title: "Éco-Prêt à Taux Zéro (éco-PTZ)", amount: "Jusqu'à 50 000€", desc: "Prêt sans intérêts pour financer vos travaux de rénovation énergétique. Remboursable sur 20 ans maximum sans frais ni intérêts.", conditions: ["Logement de plus de 2 ans", "Travaux éligibles multiples", "Via banques partenaires", "Cumulable avec MaPrimeRénov'"] },
              { title: "TVA à taux réduit", amount: "5,5% ou 10%", desc: "Taux de TVA réduit pour les travaux d'amélioration de la performance énergétique, soit une économie de 14,5 points par rapport au taux normal.", conditions: ["5,5% pour les travaux d'isolation", "10% pour la plupart des autres travaux", "Artisan doit facturer au taux réduit", "Applicable directement à la facture"] },
            ].map((a) => (
              <div className="aid-detail-card" key={a.title}>
                <h3>{a.title}</h3>
                <div className="aid-amount">{a.amount}</div>
                <p>{a.desc}</p>
                <ul>
                  {a.conditions.map((c) => (<li key={c}>✓ {c}</li>))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Prêt à vous lancer ?</h2>
          <p>Nos conseillers vous accompagnent dans toutes les démarches et optimisent vos aides</p>
          <div className="cta-buttons">
            <Link to="/#contact" className="btn btn-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Demander mon étude gratuite</Link>
            <a href="tel:0465845177" className="btn-outline-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Appeler le 04 65 84 51 77</a>
          </div>
        </div>
      </section>
    </>
  );
}
